import "./App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import TilboApps from "./pages/TilboApps";
import MileStory from "./pages/MileStory";
import Sevn from "./pages/Sevn";
import PdfViewer from "./components/PdfViewer";
import Pucked from "./pages/Pucked";
import PuckedPrivacy from "./pages/PuckedLegal/PuckedPrivacy";
import PuckedTerms from "./pages/PuckedLegal/PuckedTerms";

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Home route */}
          <Route path="/" element={<TilboApps />} />

          <Route path="/pucked" element={<Pucked />} />
          <Route path="/pucked/terms" element={<PuckedTerms />} />
          <Route path="/pucked/privacy" element={<PuckedPrivacy />} />

          <Route path="/sevn" element={<Sevn />} />
          <Route
            path="/sevn/terms"
            element={
              <PdfViewer gdriveId={"1HWD72LY_pCxR-eEqPMrh6-5PvVyYKcuO"} />
            }
          />
          <Route
            path="/sevn/privacy"
            element={
              <PdfViewer gdriveId={"1TL5g6yvO2NwzISG1fPC9BnIS9JG8_E_X"} />
            }
          />

          <Route path="/milestory" element={<MileStory />} />
          <Route
            path="/milestory/terms"
            element={
              <PdfViewer gdriveId={"1JyUE1QR8Z7VjU5vfdMQNBLEiIxqq-jcm"} />
            }
          />
          <Route
            path="/milestory/privacy"
            element={
              <PdfViewer gdriveId={"18sVw_W8O_tSud5AELWncVMeeygS17TLa"} />
            }
          />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
